import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CodeTypeModel }           from '../core/models/code-type';
import { StatementsCustomerModel } from './typings/statements.customer';
import { StatementsComponent }     from './statements.component';
import { StatementsService }       from './statements.service';
import { TableService }            from '../table/table.service';

export const StatementsStates : Array<NgHybridStateDeclaration> = [
  {
    component: StatementsComponent,
    name     : 'app.statements',
    resolve  : [
      {
        deps     : [ StatementsService ],
        resolveFn: ( statementsService : StatementsService ) : ng.IPromise<Array<CodeTypeModel>> => statementsService.getConstraintsTypes(),
        token    : 'constraints'
      },
      {
        deps     : [ StatementsService, TableService ],
        resolveFn: ( statementsService : StatementsService, tableService : TableService ) : ng.IPromise<Array<StatementsCustomerModel>> => {
          const cache = tableService.getCacheForTable('statements');

          return statementsService.getCustomersList({
              asAt          : cache.filtering.asAt,
              beginDate     : cache.filtering.beginDate,
              constraintType: cache.filtering.constraintType,
              endDate       : cache.filtering.endDate,
              includePaid   : cache.filtering.includePaid,
              statement     : cache.filtering.statement
            },
            {
              direction: cache.sorting.direction,
              field    : cache.sorting.field,
              offset   : 0,
              pageSize : cache.paging.pageSize
            });
        },
        token: 'customers'
      }
    ],
    url: '/statements'
  }
];
